angular.module('CarsSaraBo').factory('MarkupGAConfig', ['GAService', function (gaService) {
	return {
		markupGa: function () {
			const EVENT_CATEGORY = "Autos_tarifas_netas";
			const ADD_CRITERIA_LABEL = "Botón Agregar criterio de búsqueda";
			const CANCEL_BUTTON = "Botón Cancelar";
			var mapInfo = {
				"Seleccionar_criterio_busqueda": function (eventName, category) {
					gaService.notify(EVENT_CATEGORY, eventName, [category])
				},
				"Agregar_criterio_busqueda": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [ADD_CRITERIA_LABEL])
				},
				"Criterio_seleccionar_todos": function (eventName, category) {
					gaService.notify(EVENT_CATEGORY, eventName, [category])
				},
				"Criterio_eliminar_todos": function (eventName, category) {
					gaService.notify(EVENT_CATEGORY, eventName, [category])
				},
				"Criterio_borrar": function (eventName, category) {
					gaService.notify(EVENT_CATEGORY, eventName, [category])
				},
				"Buscar": function (eventName, criteria) {
					gaService.notify(EVENT_CATEGORY, eventName, [criteria])
				},
				"Expandir_sucursal": function (eventName, posName, category, company) {
					gaService.notify(EVENT_CATEGORY, eventName, [posName, category, company])
				},
				"Expandir_categoria": function (eventName, categoryName, company) {
					gaService.notify(EVENT_CATEGORY, eventName, [categoryName,company])
				},
				"Colapsar_sucursal": function (eventName, posName, category, company) {
					gaService.notify(EVENT_CATEGORY, eventName, [posName, category,company])
				},
				"Colapsar_categoria": function (eventName, categoryName, company) {
					gaService.notify(EVENT_CATEGORY, eventName, [categoryName,company])
				},
				"Ingresar_markup": function (eventName, markup) {
					gaService.notify(EVENT_CATEGORY, eventName, [markup])
				},
				"Previsualizar": function (eventName, markupPercentage) {
					gaService.notify(EVENT_CATEGORY, eventName, [markupPercentage])
				},
				"Guardar_todo": function (eventName, markupPercentage) {
					gaService.notify(EVENT_CATEGORY, eventName, [markupPercentage])
				},
				"Cancelar": function (eventName) {
					gaService.notify(EVENT_CATEGORY, eventName, [CANCEL_BUTTON])
				}
			}
			return {
				send: function (eventName, param1, param2, param3) {
					mapInfo[eventName].call(mapInfo, eventName, param1, param2, param3);
				}
			}
		}
	}
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/markup/markup-ga-config.service.js
// module id = 888
// module chunks = 3